module.exports = __webpack_public_path__ + "media/honey-icons/icon-notifications-on-f6389edb.svg";